// extracted by mini-css-extract-plugin
export default {"ValueBlock":"ValueBlock_ValueBlock__PkiOp","Label":"ValueBlock_Label__QWioK","Value":"ValueBlock_Value__EQApO","Prefix":"ValueBlock_Prefix__-lolu"};